import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case05.interviews-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem1ImageDescription: {
    id: `${PREFIX}.accordion-item1.imageDescription`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  accordionItem2ImageDescription: {
    id: `${PREFIX}.accordion-item2.imageDescription`,
  },
  accordionItem3Title: {
    id: `${PREFIX}.accordion-item3.title`,
  },
  accordionItem3Description: {
    id: `${PREFIX}.accordion-item3.description`,
  },
  accordionItem3ImageDescription: {
    id: `${PREFIX}.accordion-item3.imageDescription`,
  },
  accordionItem4Title: {
    id: `${PREFIX}.accordion-item4.title`,
  },
  accordionItem4Description: {
    id: `${PREFIX}.accordion-item4.description`,
  },
  accordionItem4ImageDescription: {
    id: `${PREFIX}.accordion-item4.imageDescription`,
  },
  bioNote: {
    id: `${PREFIX}.bio-note`,
  },
  collaboration: {
    id: `${PREFIX}.collaboration-info`,
  },
  bio1Title: {
    id: `${PREFIX}.bio1.title`,
  },
  bio1Description: {
    id: `${PREFIX}.bio1.description`,
  },
  bio2Title: {
    id: `${PREFIX}.bio2.title`,
  },
  bio2Description: {
    id: `${PREFIX}.bio2.description`,
  },
  bio3Title: {
    id: `${PREFIX}.bio3.title`,
  },
  bio3Description: {
    id: `${PREFIX}.bio3.description`,
  },
  bio4Title: {
    id: `${PREFIX}.bio4.title`,
  },
  bio4Description: {
    id: `${PREFIX}.bio4.description`,
  },
});
